import { Icon } from '@components';

import theme from '../../../../themes/colors';

const KycPendingBannerContent = () => (
  <div className="flex w-full justify-start gap-2 rounded-xl bg-cofeeYellow1 p-4 pb-6">
    <Icon
      name="alert-circle"
      stroke={theme.cofeeYellow8}
      className="mt-1 !size-5 text-cofeeYellow6"
    />
    <div className="flex cursor-default flex-col gap-1">
      <div className="text-lg font-semibold text-cofeeNeutral10">
        Action Required: KYC Update🚨!
      </div>
      <div className="text-base text-cofeeNeutral8">
        As per revised RBI guidelines, please update your KYC details at the
        earliest to ensure uninterrupted service.
        <br />
        For assistance, please contact your Account Manager.
      </div>
    </div>
  </div>
);

export default KycPendingBannerContent;
